import React, { useState, useEffect, useMemo } from "react";
import KanbanCard from "../KanbanCard/KanbanCard";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
// Sort lives at the page level now (PostsPagePersonalArea / IdeasPage
// / AllPostsPage all call sortContent on the array they pass in). The
// column used to re-sort FROM_NEWER_TO_OLDER unconditionally — that
// hard-coded direction (a) ignored the page's sort toggle so the
// kanban view never reordered when you clicked it, and (b) used the
// broken positional-args API on sortByDate so the order was always
// 'desc' regardless of which constant was passed. Just filter here;
// trust the parent's order.
import { bucketForItem } from "helpers/kanbanBucket";

const KanbanCategory = ({
  source,
  mile,
  index,
  projects,
  color,
  onEdit,
  onArchive,
  // placeholderProps,
  isAdmin,
  setModal,
  setProjectToDelete,
  setProjectToUpdate,
  setProjectListToEdit,
}) => {
  const [fontSize, setFontSize] = useState();

  // Compute the column's items DURING render (useMemo) instead of
  // routing through a useState + useEffect setter. That extra
  // setState round-trip meant the list react-beautiful-dnd
  // observed AT DROP TIME was the OLD list (still containing the
  // dragged card), and only a tick later did the new list arrive
  // — by which point dnd had already snapped the card back to
  // its original column. Computing in render makes the new list
  // available in the same commit as the Redux update, so dnd
  // sees the card already in its new bucket and the visual
  // matches.
  const FinalProjectList = useMemo(() => {
    const colKey = String(mile?.key ?? mile?._id ?? '');
    // Order is already the page-level sortContent output — keep it as-is.
    return (projects || []).filter((project) => {
      const bucket = bucketForItem(project, source);
      return bucket && String(bucket) === colKey;
    });
  }, [projects, mile, source]);

  useEffect(() => {
    const updateWidth = () => {
      const newWidth = window.innerWidth;
      if (newWidth < 900) {
        setFontSize(7);
      } else if (newWidth < 1157) {
        setFontSize(7);
      } else {
        setFontSize(7);
      }
    };

    window.addEventListener("resize", updateWidth);

    updateWidth();

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);


  return (
    <Draggable draggableId={mile?._id} index={index}>
      {(provided)=> (
    <div  {...provided.draggableProps} ref={provided.innerRef} className="board-box">
      <div
      {...provided.dragHandleProps}
        className="board-box-header pb-2 mb-2"
        style={{ borderColor: color }}
      >
        <span className="color-dot" style={{ backgroundColor: color }}></span>
        <span
          className="f-16 text-black"
        >
          {mile?.name ?? mile?.key}
        </span>
        <span className="count">{FinalProjectList?.length}</span>
      </div>

      <Droppable droppableId={mile._id} type="PROJECT">
        {(provided, snapshot) => (
          <div
            className="card-container d-flex flex-column"
            key={mile._id}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {FinalProjectList.map((project, index) => (
              <KanbanCard
                onEdit={onEdit}
                onArchive={onArchive}
                source={source}
                // STABLE per-item key, not array index. With key={index}
                // React reused the same component instance across
                // columns when a card moved — react-beautiful-dnd lost
                // the draggable's identity and snapped it back.
                key={(project && project._id) || index}
                brand={project}
                index={index}
                isAdmin={isAdmin}
                setModal={setModal}
                setProjectToDelete={setProjectToDelete}
                setProjectToUpdate={setProjectToUpdate}
                setProjectListToEdit={setProjectListToEdit}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
    )}
    </Draggable>
  );
};

export default KanbanCategory;
